import * as React from "react";
const Invitations = (props: any) => (
    <svg
        width={24}
        height={23}
        viewBox="0 0 24 23"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M2.418 21.777a2.33 2.33 0 0 1-1.708-.71A2.33 2.33 0 0 1 0 19.36V2.432Q0 1.434.71.723a2.33 2.33 0 0 1 1.708-.71h16.927q.998 0 1.709.71.71.711.71 1.709v6.861a7.4 7.4 0 0 0-1.768-.62 9 9 0 0 0-1.86-.196q-.877 0-1.662.166a9.4 9.4 0 0 0-1.542.469 4.4 4.4 0 0 0 .137-.605q.044-.302.044-.634 0-1.755-1.239-2.993-1.24-1.24-2.992-1.24-1.755 0-2.993 1.24-1.24 1.24-1.24 2.993t1.24 2.992q1.24 1.24 2.993 1.24h.302q-.393.543-.68 1.162a11 11 0 0 0-.499 1.286 11.4 11.4 0 0 0-4.156 1.058 12.8 12.8 0 0 0-3.43 2.357v1.39h7.616q.212.666.484 1.27.272.605.665 1.149zm14.509 1.209-.363-1.814a9 9 0 0 1-.68-.316 5 5 0 0 1-.65-.41l-1.753.545-1.209-2.055 1.39-1.21a6 6 0 0 1-.06-.785q0-.363.06-.786l-1.39-1.21 1.21-2.055 1.752.544q.333-.24.65-.408.318-.165.68-.317l.363-1.814h2.418l.363 1.814q.363.151.68.332t.65.454l1.753-.605L24 15.006l-1.39 1.21q.06.362.06.755t-.06.756L24 18.936l-1.21 2.055-1.752-.544a5 5 0 0 1-.65.409 9 9 0 0 1-.68.316l-.363 1.814zm1.209-3.627q.998 0 1.708-.71t.71-1.708-.71-1.709a2.33 2.33 0 0 0-1.708-.71q-.997 0-1.708.71a2.33 2.33 0 0 0-.71 1.709q0 .997.71 1.708.71.71 1.708.71"
            fill="currentColor"
        />
    </svg>
);
export default Invitations;
